import React from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'

interface Props {
  title: string
  description: string
}

function CommunityBanner({
  title,
  description,
}: Props) {
  const intl = useIntl()

  const actionButtons = [
    { text: intl.formatMessage({ id: '3E20RQmw1ho155iWO5ER', defaultMessage: 'Customer Service and Sales', description: 'Talent community button for customer service and sales department on careers page' }), href: 'https://au.smrtr.io/9syy' },
    { text: intl.formatMessage({ id: '7Lo0lIHPjotNad2Ei_LY', defaultMessage: 'Commercial', description: 'Talent community button for commercial department on careers page' }), href: 'https://au.smrtr.io/9syr' },
    { text: intl.formatMessage({ id: 'Vu1eCpA0YPSqEvDoAOgP', defaultMessage: 'Engineering', description: 'Talent community button for engineering department on careers page' }), href: 'https://au.smrtr.io/b5Cg' },
    { text: intl.formatMessage({ id: 'ibhp-GnO2Glyf8PPMfJg', defaultMessage: 'Finance', description: 'Talent community button for finance department on careers page' }), href: 'https://au.smrtr.io/9syZ' },
    { text: intl.formatMessage({ id: 'ds2O4cxKq2Qzb2WSoET6', defaultMessage: 'Marketing', description: 'Talent community button for marketing department on careers page' }), href: 'https://au.smrtr.io/9sz2' },
    { text: intl.formatMessage({ id: '8lT18q3yPewE1Gde30LB', defaultMessage: 'Product Management and Design', description: 'Talent community button for product management and design department on careers page' }), href: 'https://au.smrtr.io/9szc' },
  ]
  return (
    <Group direction="vertical">
      <MessageBanner
        kind="informational-secondary"
        align="center"
        heading={title}
        children={description}
      />
      <Group
        direction="horizontal"
        style={{ justifyContent: 'center', marginTop: rem(10) }}
        wrap="wrap"
      >
        {actionButtons.map((button, index) => (
          <TextButton
            key={index}
            href={button.href}
            kind="tertiary"
            size="medium"
          >
            {button.text}
          </TextButton>
        ))}
      </Group>
    </Group>
  )
}

CommunityBanner.displayName = 'CommunityBanner'
export default CommunityBanner
